import type { ContentHref } from '@generalTypes/apiTypes';
import { selectContentItem } from '@newStore/documentApi/documentApiSelectors';
import { createTypedSelector } from '@newStore/genericHelpers';
import { RequiredType } from '@nodeTypeConfig/configTypes';
import { isNumber } from 'lodash';
import { createError } from '../createError';
import type { AsideValidationRule } from '../validationTypes';

export const selectIsStartageLowerThanEndage: AsideValidationRule = createTypedSelector(
  [(state, href: ContentHref) => selectContentItem(state, href)],
  (contentItem) => {
    if (Number(contentItem.startage) > Number(contentItem.endage)) {
      return createError(
        'endAgeHigherThanStartAge',
        'selectIsStartageLowerThanEndage',
        'De beginleeftijd is hoger dan de eindleeftijd.',
        { component: 'ageRange', property: 'startage' },
        RequiredType.ERROR,
      );
    }
    return true;
  },
);

export const selectIsAgeRangeNotEmpty: AsideValidationRule = createTypedSelector(
  [(state, href: ContentHref) => selectContentItem(state, href)],
  (contentItem) => {
    if (!contentItem.startage || !contentItem.endage) {
      return createError(
        'ageEmpty',
        'selectIsAgeRangeNotEmpty',
        'Leeftijd is leeg.',
        { component: 'ageRange', property: 'startage' },
        RequiredType.WARNING,
      );
    }
    return true;
  },
);

export const selectIsFacetsAgeRangeValid: AsideValidationRule = createTypedSelector(
  [(state, href: ContentHref) => selectContentItem(state, href)],
  (contentItem) => {
    if (!contentItem.startage || !contentItem.endage) {
      return createError(
        'ageEmpty',
        'selectIsFacetsAgeRangeValid',
        'Als de leeftijd is leeg, wordt deze niet weergegeven in de resultaten.',
        { component: 'ageRange', property: 'startage' },
        RequiredType.WARNING,
      );
    }
    if (isNumber(contentItem.startage) && contentItem.startage < 2) {
      return createError(
        'startageLow',
        'selectIsFacetsAgeRangeValid',
        'De beginleeftijd moet 2 jaar of meer zijn.',
        { component: 'ageRange', property: 'startage' },
        RequiredType.WARNING,
      );
    }

    if (isNumber(contentItem.startage) && contentItem.startage < 2) {
      return createError(
        'endageHigh',
        'selectIsFacetsAgeRangeValid',
        'De eindleeftijd moet 18 jaar of minder zijn.',
        { component: 'ageRange', property: 'endage' },
        RequiredType.WARNING,
      );
    }
    return true;
  },
);
